/* eslint-disable @typescript-eslint/no-use-before-define */
import {useState,useEffect, useContext} from "react";
import { useQuery,useMutation } from "@apollo/client";
import { AdminContext } from "../../../context/AdminContext/AdminContext";
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import {openColAddPerfEvalModal, closeCollaboratoPerformanceEvaluationModal } from "../../../context/PerformanceEvaluationContext/Actions";
import ModalExternoEvelPerformance from './ModalExternoEvelPerformance';
import ModalAddColaboratorPerformanceEvaluation from './ModalAddColaboratorPerformanceEvaluation';
import {
  GET_PEFORMANCE_EVALUATION_COLLBORATORS,
  CREATE_COL_EMAIL_PER_EVAL,GET_ALL_PERFORMANCES_EVALUATION }
 from "../../../Querys/performanceEvaluation/querys";
import { makeStyles } from '@material-ui/core/styles';
import {
    Dialog,
    DialogTitle,
    DialogContent,  
 } from '@material-ui/core';
 import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearcherColaboradorEval from "../Components/SearcherColaboradorEval";
import BtnCreate from '../Components/BtnCreate';
import TableCollaboratorPerformanceEval from '../Components/TableCollaboratorPerformanceEval';
import { ErrorAlert } from "../../../alerts/errorAlert";
import "../css/CollaboratorsPerformanceEvalModal.css"
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { LoadingAlert } from "../../../alerts/loadingAlerts";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minWidth: '400px',  // Adjust this value as needed
    maxWidth: '1450px',  
  },  
  wideContent: {
    minWidth: '100%',    
  },  
}));

interface colSel {
  idEval: number; 
  id: number;
  lider?:{
    id:number
  }[]  
}

function encontrarObjetosPorIds(objetos: colSel[], ids: number[]): colSel[] {  
  return objetos.filter(objeto => ids.includes(objeto.id));
}

function verificarPropiedad(objetos: any, propiedad: string): boolean {
  return objetos.every((objeto:any) => propiedad in objeto);
}

function verificarPropiedadesNoDeseadas(ids:any, objetos:any, propiedadesEspecificas:any,numberFind:any) {
  for (let i = 0; i < objetos.length; i++) {
    const objeto = objetos[i];
    let propiedadesNoNull = 0;
    for (let j = 0; j < propiedadesEspecificas.length; j++) {
      const propiedad = propiedadesEspecificas[j];
      if (objeto[propiedad] !== null) {
        propiedadesNoNull++;
      }
    }
    if (propiedadesNoNull >= numberFind && ids.includes(objeto.id)) {
      return true; 
    }
  }
  return false; 
}

function arePropertiesNotNull(objects: any, properties: any): boolean {
  return objects.every((obj:any) => {
    return properties.every((prop:any) => obj[prop] !== null && obj[prop] !== undefined);
  });
}

function obtenerObjetosPorIDs(arrayDeObjetos:any, ids:any) {
  const objetosFiltrados = arrayDeObjetos.filter((objeto:any) => ids.includes(objeto.id));
  return objetosFiltrados;
}

function encontrarRepetidos(array1:any, array2:any) {
  let idsArray1 = array1.map((obj:any) => obj.id);
  let idsArray2 = array2.map((obj:any) => obj.id);
  let idsRepetidos = idsArray1.filter((id:any) => idsArray2.includes(id));
  let objetosRepetidos = array1.filter((obj:any) => idsRepetidos.includes(obj.id));
  return objetosRepetidos;
}

const CollaboratorsPerformanceEvaluation = () => {
const { adminState } = useContext(AdminContext)  
const {state, dispatch} = useContext(PerformanceEvaluationContext);  
const [infoEval,setInfoEVal]=useState<any[]>();
const [arrayCollaborators, setArrayCollaborators] = useState<any[]>([])
const [colEvalInit, setColEvalInit] = useState([])
const [colEvalFilter, setColEvalFilter] = useState([])
const [infoEvalPer, setInfoEvalPer] = useState()
const [selected, setSelected] = useState<readonly number[]>([]);
const [page, setPage] = useState(0); 
const [arrayIncidEnt, setArrayIncident] = useState([])
const [arrayEval, setArrayEval] = useState([])
const [disabledBtnSend,setDisabledBtnSend]=useState(true); 
const [test]=useState(state.reload); 

const classes = useStyles();

const idEvalDesCol= state._id 

const { data ,loading, startPolling, stopPolling,refetch} = useQuery(GET_PEFORMANCE_EVALUATION_COLLBORATORS, {
  //fetchPolicy: 'no-cache',
  variables: { idPerEval:idEvalDesCol, idCompany:adminState?.idEnterprise },   
 });    
 
 const collaborators = data?.GET_PEFORMANCE_EVALUATION_COLLBORATORS;     

 const [senColPErEval] = useMutation(CREATE_COL_EMAIL_PER_EVAL,{
  refetchQueries: [
     { 
      query: GET_PEFORMANCE_EVALUATION_COLLBORATORS ,
      variables: { idPerEval:idEvalDesCol, idCompany:adminState?.idEnterprise },
    },{
      query:GET_ALL_PERFORMANCES_EVALUATION
    }
],
 });

 useEffect(()=>{
  startPolling(500000);
  return () =>{
      stopPolling()
  }
},[startPolling,stopPolling])

useEffect(()=>{
  if(test){
    refetch()
  }
},[refetch, test])

useEffect(()=>{
  if(data?.GET_PEFORMANCE_EVALUATION_COLLBORATORS===null || data?.GET_PEFORMANCE_EVALUATION_COLLBORATORS===undefined){
    refetch()
  }
},[data?.GET_PEFORMANCE_EVALUATION_COLLBORATORS, refetch])

useEffect(() => { 

  if(data?.GET_PEFORMANCE_EVALUATION_COLLBORATORS){
    if(collaborators.length  > 0 ){    
      if(colEvalFilter.length ===0 ){
      const EvelPer:any={
          tipoEvaluacion:collaborators[0].tipoEvaluacion,
          pctLider:collaborators[0].pctLider,
          pctColegas:collaborators[0].pctColegas,
          pctClientes:collaborators[0].pctClientes,
          pctSubordinados:collaborators[0].pctSubordinados,
          pctAutoevaluacion: collaborators[0].pctAutoevaluacion
        }        
        setInfoEvalPer(EvelPer)           
        setInfoEVal(collaborators) 
        setArrayCollaborators(collaborators[0].collaborators)        
        setColEvalInit(collaborators[0].collaborators)         
      }
      else{
        const repetidos=encontrarRepetidos(collaborators[0].collaborators,colEvalFilter)
        setArrayCollaborators(repetidos)
        setPage(0) 
      }       
      }       
    } 
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [ collaborators, data?.GET_PEFORMANCE_EVALUATION_COLLBORATORS, refetch]);

useEffect(() => {    
  if(colEvalFilter.length >0){
     const ordreFilter=[...colEvalFilter]
             ordreFilter.sort((a:any, b:any)=>{ return (b.id- a.id)})
            setArrayCollaborators(ordreFilter);    
            setPage(0)    
  }
}, [colEvalFilter]);

useEffect(() => {    
  if(infoEval ){
  if(collaborators[0].tipoEvaluacion==='90'){
    const info=encontrarObjetosPorIds(arrayEval,arrayIncidEnt)
    if(info.length >0)
      {
        setDisabledBtnSend(false)
      }else{
        setDisabledBtnSend(true)
      }  
  }

  if(collaborators[0].tipoEvaluacion==='180'){    
    const propsEsp=['idLider','idColega']
    const info=verificarPropiedadesNoDeseadas(arrayIncidEnt,arrayEval,propsEsp,2)
    if(info)
    {
      setDisabledBtnSend(false)
    }else{
      setDisabledBtnSend(true)
    }  
}

if(collaborators[0].tipoEvaluacion==='270'){    
  const propsEsp=['idLider','idColega','idSubornidado']
  const info=verificarPropiedadesNoDeseadas(arrayIncidEnt,arrayEval,propsEsp,3)
  if(info)
  {
    setDisabledBtnSend(false)
  }else{
    setDisabledBtnSend(true)
  }  
}

if(collaborators[0].tipoEvaluacion==='360'){    
  const propsEsp=['idLider','idColega','idSubornidado','idCliente']
  const info=verificarPropiedadesNoDeseadas(arrayIncidEnt,arrayEval,propsEsp,4)
  if(info)
  {
    setDisabledBtnSend(false)
  }else{
    setDisabledBtnSend(true)
  }  
}
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [arrayEval, arrayIncidEnt, infoEval]);

 const addCollaborator=(id:number)=>{
     openColAddPerfEvalModal(id.toString(),true, dispatch)
  }  


  const enviaEval=async(colSend:any)=>{    
  LoadingAlert({ title: "Enviando..." }); 
  await senColPErEval({
      variables:{                   
        input: colSend,
      }                 
  });
  SuccessfulAlert({ text: 'Correo electrónico(s) enviado(s) correctamente'})

  }

  const sendCollaboratorEmail=()=>{
    setDisabledBtnSend(false)
    let colSend
    if(arrayIncidEnt.length > 0 && (arrayEval.length >0 && collaborators[0].tipoEvaluacion==='90'))
    {
       colSend=encontrarObjetosPorIds(arrayEval,arrayIncidEnt)
       if(!verificarPropiedad(colSend,'lider')){
        setDisabledBtnSend(true)
        return ErrorAlert({ text: `Es necesario seleccionar al líder de cada colaborador.`});
       }        
       enviaEval(colSend)
       setDisabledBtnSend(true)
      }

  if(collaborators[0].tipoEvaluacion==='180'){
   const res = obtenerObjetosPorIDs(arrayEval,arrayIncidEnt)
   const propsEsp=['idLider','idColega']
    const info=arePropertiesNotNull(res,propsEsp)
    if(info){
     enviaEval(res)
     setDisabledBtnSend(true)
    }else{
      setDisabledBtnSend(true)
      return ErrorAlert({ text: `Es necesario seleccionar a todos los evaluadores.`});
      
    }
  }

  if(collaborators[0].tipoEvaluacion==='270'){
    const res = obtenerObjetosPorIDs(arrayEval,arrayIncidEnt)
    const propsEsp=['idLider','idColega','idSubornidado']
    const info=arePropertiesNotNull(res,propsEsp)
    if(info){
     enviaEval(res)
     setDisabledBtnSend(true)
    }else{
      setDisabledBtnSend(true)
      return ErrorAlert({ text: `Es necesario seleccionar a todos los evaluadores.`});
      
    }
   }

   if(collaborators[0].tipoEvaluacion==='360'){
    const res = obtenerObjetosPorIDs(arrayEval,arrayIncidEnt)
    const propsEsp=['idLider','idColega','idSubornidado','idCliente']
    const info=arePropertiesNotNull(res,propsEsp)
    if(info){
     enviaEval(res)
     setDisabledBtnSend(true)
    }else{
      setDisabledBtnSend(true)
      return ErrorAlert({ text: `Es necesario seleccionar a todos los evaluadores.`});      
    }
   }  
  }  

  const closeModalColPerEval=()=>{    
    setArrayEval([])
    setDisabledBtnSend(true)
    closeCollaboratoPerformanceEvaluationModal("",false,false, dispatch)
   }

  return (
    <>    
        <Dialog
        open={state.modalCollaboratorPerformanceEvaluation}
        aria-labelledby="modal-dialog-title"
        className="containerMdalModel customDialogContent"
        fullWidth={true}                
        classes={{ paper: classes.dialogPaper }}
        >
        <IconButton
            aria-label="close"
            sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}
            onClick={(() => { closeModalColPerEval() })}
        >
        <CloseIcon />
       </IconButton>
       {(loading === true) ?
        <div className="c_contenedorPrincipal">
          <div className="contenedorLoadingPrincipal">
            <div className="loadingPrincipal"></div>
          </div>
        </div>
        :
        colEvalInit?.length === 0? 
        <div className="c_contenedorPrincipal">
        <div className="contenedorLoadingPrincipal">
          <div className="loadingPrincipal"></div>
        </div>
      </div>
        :
        <>
       <DialogContent className='contentTitleColPerEv'>
            <DialogContent  className='infoTitleColPerEv'>
              {infoEval && (
                <>
               <DialogTitle className="contNamePerEv"><span className="txtNamePerEv">{infoEval[0]?.namePerformance}</span></DialogTitle>
               <DialogTitle className="contTypePerEv"><span className="txtTypePerEv">Evaluación {infoEval[0]?.tipoEvaluacion}&deg;</span></DialogTitle>            
               </>
              )
              }
            </DialogContent>
            <DialogContent className='btnTitleColPerEv'>
             <SearcherColaboradorEval 
               initState={arrayCollaborators}
               setState={setColEvalFilter}   
               stateInitial={colEvalInit}             
               label={"Colaborador / Sede / Área"}
               fields={['colaborador','sede','proyecto']}
               width={320}
            
             />
             <button className="botonReturn"
                        type="button"
                        onClick={(() => {closeModalColPerEval(); })}
                >
                        <span className='bttnsTxt'>Regresar</span>
             </button>
             {infoEval && (
             <BtnCreate
              txtBtn="Agregar Colaborador" 
              id={infoEval[0]?.id}
              openModal={addCollaborator}
             />           
              )
            }
            <BtnCreate
              txtBtn="Enviar"             
              openModal={sendCollaboratorEmail}
              disabledBtn={disabledBtnSend}
             />
             
            </DialogContent>
       </DialogContent>
       <DialogContent  
        className={`scroller`}
       >
       <div className={classes.wideContent}>
       {
        colEvalInit?.length > 0 && (
         <TableCollaboratorPerformanceEval
          rows={arrayCollaborators}
          setArrayIncident={setArrayIncident}
          selected={selected}
          setSelected={setSelected}
          page={page}          
          setPage={setPage}

          info={infoEvalPer}
          arrayEval={arrayEval}
          setArrayEval={setArrayEval}              
         /> 
            )}
       </div>
      </DialogContent>
      </>
      }
   </Dialog>     

   {state._id !=='' &&(
        <>       
      <ModalExternoEvelPerformance/>
      <ModalAddColaboratorPerformanceEvaluation/>
      </>
      )
    }   
   </>
 

  )
}

export default CollaboratorsPerformanceEvaluation
